import React from 'react'
import { DialogTitle } from '@material-ui/core'
import { scheduleModalClose } from '../../actions/publishSchedule'
import { usePublishSchedule } from './hooks'
import { AddPublishScheduleForm } from './AddPublishScheduleForm'
import { StyledDialog } from './styled'

export const AddPublishScheduleModal = () => {
  const [{ displayModal, currentScheduleId }, dispatch] = usePublishSchedule()
  return (
    <StyledDialog
      fullWidth
      disableBackdropClick
      open={displayModal}
      onClose={() => dispatch(scheduleModalClose())}
      classes={{ paper: 'dialog-paper-root' }}
      aria-labelledby="schedule-dialog-title"
      aria-describedby="schedule-dialog-description"
    >
      <DialogTitle id="schedule-dialog-title">{currentScheduleId ? 'Update' : 'New'} schedule</DialogTitle>
      <AddPublishScheduleForm />
    </StyledDialog>
  )
}
